// extracted by mini-css-extract-plugin
export default {"wrapperContent":"ekkEi","content":"X__LF","column":"_kAaL","regionPosition":"ZlOqL"};